import React from "react";

import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";

const CollapseCell = ({ contentID, collapseOpen, innerContent, Rule }) => {
  return (
    <TableCell
      style={{
        paddingBottom: 0,
        paddingTop: 0,
      }}
    >
      <Collapse
        sx={{
          maxHeight: "300px",
          overflowY: "auto",
        }}
        in={collapseOpen.id === contentID && collapseOpen.open === true}
        timeout="auto"
      >
        {innerContent ? (
          <Box sx={{ margin: 1 }}>
            <Typography variant="body2" gutterBottom component="div" fontWeight="bold">
              {Rule}:
            </Typography>
            <pre>{JSON.stringify(innerContent, null, 2)}</pre>
          </Box>
        ) : (
          <></>
        )}
      </Collapse>
    </TableCell>
  );
};

export default React.memo(CollapseCell);
